import React from 'react';
import PropTypes from 'prop-types';
import formattedDate from 'lib/common/formattedDate';

const PerformanceSelector = React.createClass({
  propTypes: {
    currentPerformanceId: PropTypes.number.isRequired,
    onChangePerformance: PropTypes.func.isRequired,
    performances: PropTypes.array,
    isAvailable: PropTypes.bool.isRequired // eslint-disable-line react/no-unused-prop-types
  },
  handleChange: function(event) {
    let performanceId = parseInt(event.target.value, 10);
    this.props.onChangePerformance(performanceId);
  },
  render: function() {
    let { currentPerformanceId } = this.props;
    let performances = this.props.performances.filter(performance => {
      return performance.on_sale_ind !== 'N';
    });

    return performances.length > 1 ? (
      <div className="syos-performance-selector">
        <label
          className="syos-performance-selector__label"
          htmlFor="syos-performance-selector"
        >
          Select a different performance:
        </label>
        <select
          className="syos-performance-selector__select"
          value={currentPerformanceId}
          onChange={this.handleChange}
          id="syos-performance-selector"
        >
          <optgroup label="Select a performance">
            {performances.map((performance, idx) => {
              return (
                <option
                  value={performance.perf_no}
                  key={idx}
                  disabled={
                    performance.availbility_by_customer == '0' &&
                    performance.gross_availbility == '0' ? (
                      true
                    ) : (
                      false
                    )
                  }
                >
                  {formattedDate(performance.perf_date)}
                </option>
              );
            })}
          </optgroup>
        </select>
      </div>
    ) : null;
  }
});

export default PerformanceSelector;



// WEBPACK FOOTER //
// ./src/javascripts/app/components/PerformanceSelector.js